<div class="rd-widget table-widget">
  <table class="widgetLeaseComparablesSummaryClass widget-large cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="32" class="lease-up-costs-widget-header-red" style="text-align: start;">
            <widget-value class="lease-up-costs-widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">Lease Comps Summary</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="2">
            <widget-value [color]="'white'" [align]="'left'">No.</widget-value>
          </th>
          <th scope="col" colspan="6">
            <widget-value [color]="'white'" [align]="'left'">Name</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Year Blt.</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usLeaseCompsCat7Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Tenant</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Escalations</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Rent / SF</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Net Effective Rent</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="3" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="2">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="6">
            <widget-value [color]="'white'" [align]="'left'">Address</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Total RA</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usLeaseCompsCat8Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Lease Start</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">T.I. / S.F.</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Lease Type</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="4" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="2">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="6">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usLeaseCompsCat2Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">{{widgetData.labels.usLeaseCompsCat9Label}}</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Leased SF</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Free Rent</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">Term (Mos.)</widget-value>
          </th>
          <th scope="col" colspan="4">
            <widget-value [color]="'white'" [align]="'left'">&nbsp;</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody class="extraTbody">
      <ng-container *ngFor="let entry of widgetData.rows; let i = index">
        <dynamic-growth-row [row]="5 + i * 3" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="2">
              <widget-value [align]="'left'">{{entry.usLeaseCompsNo}}</widget-value>
            </td>
            <td colspan="6">
              <widget-value [align]="'left'">{{entry.usLeaseCompsName}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsYearBuilt}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usLeaseCompsCat7 | rdLocalizedDynamicField}}%</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">-</widget-value> <!--Missing the mapping-->
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsEscalations}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsRentPerArea}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsNetEffectiveRent}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
        <dynamic-growth-row [row]="6 + i * 3" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="2">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="6">
              <widget-value [align]="'left'">{{entry.usLeaseCompsAddressLine1}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsTotalRA}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usLeaseCompsCat8 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsLeaseStart | rdLocalizedDate}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsTIperArea}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsLeaseType}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
        <dynamic-growth-row [row]="6 + i * 3" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="2">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
            <td colspan="6">
              <widget-value [align]="'left'">{{entry.usLeaseCompsAddressLine2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usLeaseCompsCat2 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usLeaseCompsCat3 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.dynamicData.usLeaseCompsCat9 | rdLocalizedDynamicField}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsFreeRent}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usLeaseCompsTermMos}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">&nbsp;</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
    </tbody>
  </table>
</div>

